     <p style="padding: 0% 2%;"><span style="color: gray;" translate>E-Content / Cources </span> <span translate>/ Semester</span></p>
      <div class="d-flex align-items-center" style="padding: 0% 2%;">
       <div style="width: 5%;">
           <button class="back_icon me-2" (click)="navigateToBackPage()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
        </div>
        <div style="width: 46%;">
          <h2 style="margin: 1% 0% 1% 1%;" translate>Subjects</h2>
        </div>

        <div style="width: 50%;">
          <button
          style="float: right;"
           mat-raised-button
           color="primary"
           (click)="addEcontent()"
          >
            <i class="fa-solid fa-plus"></i>
                <span translate>Add E-Content</span>
        </button>
        </div>
      </div>
<section class="container section">
  <div class="app-container">
    <main class="content-container">
      <nav class="semester-nav">
        <ul class="semester-list">
          <li
            *ngFor="let semester of semesters"
            (click)="selectSemester(semester.semister_id)"
            [class.selected]="semester.semister_id === selectedSemester"
            class="semester-item"
          >
            <span class="semester-number"
              ><span translate>Semester</span> {{ semester.Semester_Number }}</span
            >
            <mat-icon
              class="chevron-icon"
            >
              chevron_right
            </mat-icon>
          </li>
        </ul>
      </nav>

      <section class="subject-content">
        <div
          *ngIf="selectedSemester; else noSelection"
          class="subject-container"
        >
          <!-- <h2 class="section-title">Subjects</h2> -->
          <ul class="subject-list">
            <li
              *ngFor="let subject of subjectsList; let i = index"
              class="subject-item"
              (click)="viewESubjectData(subjectsId[i],subject)"
            >
              <div>
                <mat-icon class="subject-icon" color="primary" style="font-size: 34px !important;"
                  >menu_book</mat-icon
                >
                <div>
                  <div>
                    <div class="subject-name">{{ subject }}</div>
                    <div class="subject-code">
                      {{ subjectsCode[i] }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <ng-template #noSelection>
          <div class="empty-state">
            <mat-icon class="empty-icon">select_all</mat-icon>
            <h3 translate>No Semester Selected</h3>
            <p translate>Please select a semester from the list to view its subjects</p>
          </div>
        </ng-template>
      </section>
    </main>
  </div>
</section>
